"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarSeparator = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ToolbarPropsContext = require("../context/ToolbarPropsContext");
var _toolbarTheme = require("./toolbarTheme");
const ToolbarSeparator = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    isCollapsibleButton,
    containmentVariant = "default",
    toolbarSize
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    renderOn,
    omitButtonGroupSeparators
  } = (0, _ToolbarPropsContext.useToolbarPropsContext)();
  const excludeSeparator = isCollapsibleButton ? false : omitButtonGroupSeparators;
  return /*#__PURE__*/_react.default.createElement(ToolbarSeparatorStyled, {
    containmentVariant: containmentVariant,
    themeMode: themeMode,
    renderOn: renderOn,
    omitButtonGroupSeparators: excludeSeparator,
    ref: ref,
    toolbarSize: toolbarSize
  });
});
exports.ToolbarSeparator = ToolbarSeparator;
ToolbarSeparator.displayName = "ToolbarSeparator";
const ToolbarSeparatorContainmentHeight = "40px";
const ToolbarSeparatorBackgroundColor = (0, _designTokensReact.color)("color--border--neutral--weakest", "#e5e7f0");
const ToolbarSeparatorWidth = "1px";
const containmentVariantMap = (renderOn, themeMode, toolbarSize) => ({
  default: {
    backgroundColor: _toolbarTheme.toolbarSeparatorTheme.color[renderOn](themeMode),
    height: toolbarSize === "xxSmall" ? "20px" : _toolbarTheme.toolbarSeparatorTheme.height(themeMode),
    margin: _toolbarTheme.toolbarSeparatorTheme.margin(themeMode),
    width: _toolbarTheme.toolbarSeparatorTheme.width(themeMode)
  },
  full: {
    backgroundColor: ToolbarSeparatorBackgroundColor,
    height: ToolbarSeparatorContainmentHeight,
    margin: `0 ${_designTokens.space.space20}`,
    width: ToolbarSeparatorWidth
  }
});
const ToolbarSeparatorStyled = (0, _styled.default)("div")`
    height: ${_ref2 => {
  let {
    containmentVariant,
    renderOn,
    themeMode,
    toolbarSize
  } = _ref2;
  return containmentVariantMap(renderOn, themeMode, toolbarSize)[containmentVariant].height;
}};
    width: ${_ref3 => {
  let {
    containmentVariant,
    renderOn,
    themeMode,
    toolbarSize
  } = _ref3;
  return containmentVariantMap(renderOn, themeMode, toolbarSize)[containmentVariant].width;
}};
    background-color: ${_ref4 => {
  let {
    containmentVariant,
    renderOn,
    themeMode,
    toolbarSize
  } = _ref4;
  return containmentVariantMap(renderOn, themeMode, toolbarSize)[containmentVariant].backgroundColor;
}};
    margin: ${_ref5 => {
  let {
    containmentVariant,
    renderOn,
    themeMode,
    toolbarSize
  } = _ref5;
  return containmentVariantMap(renderOn, themeMode, toolbarSize)[containmentVariant].margin;
}};
    display: ${_ref6 => {
  let {
    omitButtonGroupSeparators
  } = _ref6;
  return `${omitButtonGroupSeparators ? "none" : "inline-block"}`;
}};
`;
//# sourceMappingURL=ToolbarSeparator.js.map